/* Weight Loss Reset - CRO PDP behaviour
   Scoped to .wlr. Safe to load on any page; every hook is optional. */
(function () {
  'use strict';

  var root = document;
  var docBound = false;

  /* ---------------- Plan selector ---------------- */
  function initPlans() {
    var plans = Array.prototype.slice.call(root.querySelectorAll('.wlr .plan'));
    if (!plans.length) return;

    var stickyPrice = root.getElementById('wlr-sticky-price');
    var stickyPlan = root.getElementById('wlr-sticky-plan');
    var cartCta = root.getElementById('wlr-cart-cta');
    var variantInput = root.getElementById('wlr-variant-id');
    var ctaLabel = cartCta ? (cartCta.getAttribute('data-label') || 'Add to cart') : '';

    function choose(chosen) {
      plans.forEach(function (p) {
        p.setAttribute('aria-pressed', p === chosen ? 'true' : 'false');
      });

      var price = chosen.getAttribute('data-plan-price') || '';
      var name = chosen.getAttribute('data-plan-name') || '';
      var variant = chosen.getAttribute('data-variant-id') || '';

      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyPlan) stickyPlan.textContent = name;
      if (variantInput) variantInput.value = variant;
      if (cartCta) {
        cartCta.textContent = ctaLabel + ' \u2014 ' + price;
        cartCta.setAttribute('aria-label', ctaLabel + ' ' + name + ' for ' + price);
        cartCta.disabled = !variant;
      }
    }

    plans.forEach(function (p) {
      if (p.dataset.wlrBound) return;
      p.dataset.wlrBound = '1';
      p.addEventListener('click', function () { choose(p); });
    });

    // Never land on a sold-out option: aria-pressed is set by loop position
    // in Liquid, which has no knowledge of availability.
    var enabled = plans.filter(function (p) { return !p.disabled; });
    var pool = enabled.length ? enabled : plans;
    var preselected = pool.filter(function (p) {
      return p.getAttribute('aria-pressed') === 'true';
    })[0];
    choose(preselected || pool[0]);
  }

  /* ---------------- Add to cart ---------------- */
  function openThemeCartDrawer() {
    if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.openAndRefresh === 'function') {
      try {
        window.KozlerCartDrawer.openAndRefresh();
        return true;
      } catch (err) {}
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    var cartIcon = document.querySelector('[data-kozler-cart-open], [data-cart-icon], [aria-controls="CartDrawer"]');
    if (cartIcon) {
      try { cartIcon.click(); return true; } catch (err) {}
    }
    return !!document.querySelector('#CartDrawer, [data-modal="cart"], cart-drawer');
  }

  function initCart() {
    var form = root.getElementById('wlr-buy-form');
    if (!form) return;
    if (form.dataset.wlrBound) return;
    form.dataset.wlrBound = '1';

    var mode = form.getAttribute('data-cart-mode') || 'cart';
    // 'cart' and 'checkout' are plain POSTs - no JS needed, and every
    // cart-level discount / offer rule still runs server-side.
    if (mode !== 'ajax') return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('#wlr-cart-cta');
      var restore = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      var variantId = Number(form.querySelector('#wlr-variant-id').value);
      if (!variantId) {
        if (btn) { btn.disabled = false; btn.textContent = restore; }
        return;
      }

      if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.beginAdd === 'function') {
        try { window.KozlerCartDrawer.beginAdd(); } catch (err) {}
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || 'Could not add to cart');
          openThemeCartDrawer();
          if (btn) {
            btn.textContent = 'Added';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = restore;
            }, 900);
          }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = restore; }
          window.console && console.error('[wlr] add to cart failed:', err);
        });
    });
  }

  /* ---------------- Sticky buy bar ---------------- */
  function initSticky() {
    var sticky = root.querySelector('.wlr .sticky-buy');
    var offer = root.getElementById('offer');
    if (!sticky || !offer) return;
    if (sticky.dataset.wlrBound) return;
    sticky.dataset.wlrBound = '1';

    function update() {
      var past = window.scrollY > offer.offsetTop + offer.offsetHeight - 70;
      sticky.classList.toggle('show', past);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------------- Review rail drag ---------------- */
  function initRails() {
    Array.prototype.slice.call(root.querySelectorAll('.wlr .review-rail')).forEach(function (rail) {
      if (rail.dataset.wlrBound) return;
      rail.dataset.wlrBound = '1';
      var dragging = false, startX = 0, startLeft = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        dragging = true;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
        rail.classList.add('dragging');
        rail.setPointerCapture(e.pointerId);
      });
      rail.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        rail.scrollLeft = startLeft - (e.clientX - startX);
      });
      function stop(e) {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('dragging');
        if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId);
      }
      rail.addEventListener('pointerup', stop);
      rail.addEventListener('pointercancel', stop);
    });
  }

  /* ---------------- Reviews expand / collapse ----------------
     This theme's core-modal-portal claims any button carrying
     aria-controls / aria-expanded and turns it into a modal --
     full-screen scrim plus scroll lock. So the toggle uses
     aria-pressed + a data attribute, swaps a custom class rather
     than [hidden] or .is-open, and kills the event before the
     portal's delegated listener ever sees it.                    */
  function initReviewToggle() {
    Array.prototype.slice.call(root.querySelectorAll('.wlr [data-wlr-toggle-reviews]')).forEach(function (btn) {
      if (btn.dataset.wlrBound) return;
      btn.dataset.wlrBound = '1';

      var panel = root.getElementById(btn.getAttribute('data-wlr-panel'));
      if (!panel) return;

      var more = btn.querySelector('[data-label-more]');
      var less = btn.querySelector('[data-label-less]');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        var open = panel.classList.toggle('wlr-shown');
        btn.setAttribute('aria-pressed', open ? 'true' : 'false');
        if (more) more.hidden = open;
        if (less) less.hidden = !open;
        if (!open) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------------- Scroll-to hooks ---------------- */
  function initScrollTo() {
    if (docBound) return;
    docBound = true;
    root.addEventListener('click', function (e) {
      var control = e.target.closest && e.target.closest('.wlr [data-scroll-target]');
      if (!control) return;
      var target = root.getElementById(control.getAttribute('data-scroll-target'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function boot() {
    initPlans();
    initCart();
    initSticky();
    initRails();
    initReviewToggle();
    initScrollTo();
  }

  if (window.__wlrPdpLoaded) return;
  window.__wlrPdpLoaded = true;

  if (root.readyState === 'loading') {
    root.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-bind when the theme editor swaps a section in.
  root.addEventListener('shopify:section:load', boot);
  root.addEventListener('shopify:section:select', boot);
}());
